module.exports = __webpack_public_path__ + "img/logo-pdf.bac7f674.png";